import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { webSocket } from "rxjs/webSocket";
import {
  HttpClient,
  HttpResponse,
  HttpParams,
  HttpHeaders
} from "@angular/common/http";
import { map } from "rxjs/operators";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root"
})
export class JourneySocketService {
  private subject = new Subject<any>();
  constructor(private http: HttpClient) { }

  /**
   * How to use
    this.wsConnection = this.datacontextService.journeySocket.connect();
    this.wsConnection.subscribe(
      (msg) => {
        console.log('WS:', msg);
      },
      (err) => {
        console.error('WS:', err);
      },
      () => console.log('complete')
    );

    this.wsConnection.next();
   */

  connect(sid: string) {
    const url = `${environment['wssocket_url']}/socket/${sid}?source=browser`;
    this.subject = webSocket(url);
    return this.subject;
  }

  requestSession(appID: string, deviceID: string) {
    const payload = {
      app_id: appID,
      device_id: deviceID,
      source: 'browser'
    };

    const url = '/dashboard/visualizer/request_session';
    return this.http.post<any>(url, payload).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  freeDevice(appID: string, deviceID: string) {
    const url = 'dashboard/visualizer/free_device/' + deviceID;
    const httpOptions = {
      headers: new HttpHeaders({
        'app-id': appID
      })
    };

    return this.http.get<any>(url, httpOptions).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }
}
